export default "__VITE_ASSET__DTlzXbeL__"